// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
// App Specific
import Home from '@/components/LangGG/Home'
import TagPage from '@/components/LangGG/TagPage'
import GamePage from '@/components/LangGG/GamePage'
import Profile from '@/components/LangGG/Profile'
import Login from '@/components/LangGG/Login'
import PaymentError from '@/components/LangGG/PaymentError'
// Lang Specific
import LP from '@/components/LangGG/RS/LP'
import Deactivation from '@/components/LangGG/RS/Deactivation'
import Contact from '@/components/LangGG/RS/Contact'
import Imprint from '@/components/LangGG/RS/Imprint'
import Terms from '@/components/LangGG/RS/Terms'
import Wait from '@/components/LangGG/RS/Wait'
import DataProtection from '@/components/LangGG/RS/DataProtection'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/tag/:name',
            name: 'TagPage',
            component: TagPage
        },
        {
            path: '/game/:id',
            name: 'GamePage',
            component: GamePage
        },
        {
            path: '/deactivation',
            name: 'Deactivation',
            component: Deactivation
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: Imprint
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/wait',
            name: 'Wait',
            component: Wait
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        },
        {
            path: '/data-protection',
            name: 'DataProtection',
            component: DataProtection
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/gg/rs.js